var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('register-form')],1),_c('div',{staticClass:"col-md-6"},[_c('login-form')],1),_c('div',{staticClass:"col-md-12"},[_c('type-validation-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }